import React from 'react';
import { useSelector } from 'react-redux';
import './PayeeTaxInformation.scss';
import Phone from 'src/components/Shared/Phone/Phone';
import Button from 'src/components/Shared/Button/Button';
import { COLLEGE_FUND_NOTE_PHONE_NUMBERS } from 'src/settings/settings';

const PayeeTaxInformation = (props) => {
  const sellLookup = useSelector((state) => state.sellTransaction.sellLookup);
  const address =
    sellLookup?.[props.fund.agreementID]?.mailCheckBeneficiaryAddress;
  return (
    <div className="payee-tax-modal">
      <h4> Payee Tax Information</h4>
      <p>
        By selecting beneficiary as the payee, all tax documentation [i.e.
        1099Q] will be sent to the beneficiary's address of record
      </p>
      {address?.street1 && (
        <p>
          {address?.street1}, {address?.city}, {address?.state} {address?.zip}
        </p>
      )}
      <p>
        To update a beneficiary address of record, please call us at{' '}
        <Phone
          phoneNumber={
            COLLEGE_FUND_NOTE_PHONE_NUMBERS[props?.fund?.productType]
          }
        />{' '}
        to speak with an associate.
      </p>
      <div className="payee-btn-container">
        <div></div>
        <Button
          className="defer-delete-success-button"
          buttonType="primary"
          styleName="defer-delete-success-button"
          id="delete-btn"
          onClick={() => props.closeModal()}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default PayeeTaxInformation;
